.container {
  container: mantine-grid / inline-size;
}

.root {
  --grid-overflow: visible;
  --grid-column-gap: var(--grid-gap);
  --grid-row-gap: var(--grid-gap);

  overflow: var(--grid-overflow);
}

.inner {
  display: flex;
  flex-wrap: wrap;
  justify-content: var(--grid-justify);
  align-items: var(--grid-align);
  gap: var(--grid-row-gap) var(--grid-column-gap);
}

.col {
  --col-flex-grow: 0;
  --col-offset: 0rem;

  flex-shrink: 0;
  order: var(--col-order);
  flex-basis: var(--col-flex-basis);
  width: var(--col-width);
  max-width: var(--col-max-width);
  flex-grow: var(--col-flex-grow);
  margin-inline-start: var(--col-offset);
  align-self: var(--col-align-self);
}
